<template>
  <div class="site-poster-container">
    <img src="../assets/common/site-access-poster.svg" alt="Site Access Poster" class="site-access-poster" />
    <img src="../assets/common/standard-logo.svg" alt="Standard Logo" class="standard-logo" />
  </div>
</template>

<script>
export default {
  name: 'SitePosterSvg',
};
</script>

<style>
.standard-logo {
  position: absolute;
  background-color: white;
  height: 100px !important;
  left: 0 !important;
  top: calc(80% - 6px) !important;
}
</style>
